<template>
  <span class="panel-nav__item" @click="forward">
    <span class="panel-nav__item__inner" :class="{'is-current': value === currentValue}">
      <slot></slot>
    </span>
    <span class="panel-nav__separator">{{separator}}</span>
  </span>
</template>

<script>
import Emitter from '@/global/mixins/emitter'

export default {
  name: 'PanelNavItem',
  componentName: 'PanelNavItem',
  mixins: [Emitter],
  props: {
    to: {},
    replace: Boolean,
    go: Boolean,
    value: String
  },
  data () {
    return {
      separator: ''
    }
  },
  computed: {
    isNav () {
      let parent = this.$parent
      while (parent) {
        if (parent.$options.componentName !== 'PanelNav') {
          parent = parent.$parent
        } else {
          this._panelNav = parent
          return true
        }
      }
      return false
    },
    currentValue () {
      return this.isNav ? this._panelNav.value : ''
    }
  },
  methods: {
    forward () {
      if (this.to) {
        const to = this.to
        if (this.$router) {
          // this.replace
          //   ? this.$router.replace(to)
          //   : this.go ? this.$router.go(to) : this.$router.push(to)
        } else {
          location.href = to
        }

        this.dispatch('PanelNav', 'input', [this.value])
      }
    }
  },
  mounted () {
    this.separator = this.$parent.separator
  }
}
</script>

<style lang="scss">
@include b(panel-nav-item) {
}
</style>
